import React from 'react';

interface ProductTourProgressProps {
  current: number;
  total: number;
}

const ProductTourProgress: React.FC<ProductTourProgressProps> = ({ current, total }) => {
  const percentage = total > 0 ? ((current + 1) / total) * 100 : 0;

  return (
    <div className="space-y-1.5">
      <div className="h-1.5 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500 ease-out"
          style={{
            width: `${percentage}%`,
            background: 'linear-gradient(to right, #42389D, #5B4FC7)',
          }}
        />
      </div>
      <p className="text-xs text-gray-500 text-right">
        {current + 1} of {total}
      </p>
    </div>
  );
};

export default ProductTourProgress;
